
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Stkpi13Component } from './stkpi13Pkg.component';
import { Stkpi13DetailComponent } from './stkpi13-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-stkpi13-bill',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, Stkpi13Component, Stkpi13DetailComponent],
  templateUrl: './stkpi13BillPkg.component.html',
  styleUrls: [],
})
export class Stkpi13BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' stkpi13'; //###
  override masterPage!: Stkpi13Component;
  override detailPage!: Stkpi13DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
